import { initNvFetch } from '../../shared/helpers/nvFetch';
import { initPartnerCrmHelper } from '../helpers/partnerCrm';
import configureStore from './configureStore';

const store = configureStore();

initNvFetch(store);
initPartnerCrmHelper(store);

export type { Store, StoreDispatch, StoreState, ThunkAPI } from './types';

export default store;
